// @ts-expect-error static asset
import blobsImageUrl1x from 'bender-url!../../img/provider-ctas-blob-1x.png';
// @ts-expect-error static asset
import blobsImageUrl2x from 'bender-url!../../img/provider-ctas-blob-2x.png';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { CardHeader, CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { Logo } from 'foundations-components/transitional/components/Logo';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { Fragment } from 'react';
import styled from 'styled-components';
import { getAppPartnerSignupUrl, getSolutionPartnerSignupUrl, getTemplateProviderSignupUrl } from '../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "ProviderSignupSection__StyledDiv",
  componentId: "iils4y-0"
})(["display:flex;flex-direction:column;align-items:center;padding:", ";background-color:", ";background-image:url(", ");background-image:image-set( url(", ") 1x,url(", ") 2x );background-position:100% 100%;background-repeat:no-repeat;"], ({
  theme
}) => `${theme.space['1500']} ${theme.space['800']}`, ({
  theme
}) => theme.color['fill-surface-raised'], blobsImageUrl1x, blobsImageUrl1x, blobsImageUrl2x);
function CardTitle({
  children
}) {
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(Logo, {
      display: "block",
      marginBlockEnd: "300",
      name: "hubspot-wordmark",
      height: 24
    }), children]
  });
}
function Card({
  button,
  description,
  subtitle,
  title
}) {
  return /*#__PURE__*/_jsxs(CardWrapper, {
    children: [/*#__PURE__*/_jsx(CardHeader, {
      title: /*#__PURE__*/_jsx(CardTitle, {
        children: title
      }),
      titleTagName: "h3"
    }), /*#__PURE__*/_jsxs(CardSection, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "span",
        typography: "heading-400",
        children: subtitle
      }), /*#__PURE__*/_jsx("p", {
        children: description
      })]
    }), /*#__PURE__*/_jsx(CardSection, {
      children: button
    })]
  });
}
export default function ProviderSignupSection({
  onTrackInteraction
}) {
  const {
    columns
  } = useResponsiveProps({
    columns: {
      sm: 1,
      md: 2,
      lg: 3
    }
  });
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StyledDiv, {
      "data-test-id": "provider-signup-section",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        maxInlineSize: "1280px",
        flexDirection: "column",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h2",
          marginBlockEnd: "1300",
          textAlign: "center",
          typography: "heading-600",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceUnified.sections.providerSignup.title"
          })
        }), /*#__PURE__*/_jsxs(CardGrid, {
          columns: columns,
          gutterSize: 12,
          children: [/*#__PURE__*/_jsx(Card, {
            button: /*#__PURE__*/_jsx(Button, {
              use: "tertiary",
              "data-test-id": "provider-signup-button",
              href: getTemplateProviderSignupUrl(),
              onClick: () => onTrackInteraction('click asset provider signup button'),
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketplaceUnified.sections.providerSignup.templateMarketplace.buttonText"
              })
            }),
            description: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplaceUnified.sections.providerSignup.templateMarketplace.description"
            }),
            subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplaceUnified.sections.providerSignup.templateMarketplace.subtitle"
            }),
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplaceUnified.sections.providerSignup.templateMarketplace.title"
            })
          }), /*#__PURE__*/_jsx(Card, {
            button: /*#__PURE__*/_jsx(Button, {
              use: "tertiary",
              "data-test-id": "provider-app-partner-button",
              href: getAppPartnerSignupUrl(),
              onClick: () => onTrackInteraction('click app developer signup button'),
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketplaceUnified.sections.providerSignup.appMarketplace.buttonText"
              })
            }),
            description: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplaceUnified.sections.providerSignup.appMarketplace.description"
            }),
            subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplaceUnified.sections.providerSignup.appMarketplace.subtitle"
            }),
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplaceUnified.sections.providerSignup.appMarketplace.title"
            })
          }), /*#__PURE__*/_jsx(Card, {
            button: /*#__PURE__*/_jsx(Button, {
              use: "tertiary",
              "data-test-id": "provider-hubspot-partner-button",
              href: getSolutionPartnerSignupUrl(),
              onClick: () => onTrackInteraction('click solution provider signup button'),
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketplaceUnified.sections.providerSignup.solutionsDirectory.buttonText"
              })
            }),
            description: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplaceUnified.sections.providerSignup.solutionsDirectory.description"
            }),
            subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplaceUnified.sections.providerSignup.solutionsDirectory.subtitle"
            }),
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplaceUnified.sections.providerSignup.solutionsDirectory.title"
            })
          })]
        })]
      })
    })
  );
}